import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$1 } from './mapy-loader3.js';
import { o as transDialog, g as getLocale, B as classNames } from './utils2.js';
import { d as defineCustomElement$2 } from './mapy-loader2.js';

const mapyReviewDialogConfirmationCss = ".confirmation{background:rgba(235, 235, 235, 1);padding:16px}.confirmation-inner{display:flex;gap:1px;border-radius:4px;overflow:hidden;position:relative;box-shadow:0px 4px 16px 0px rgba(0, 0, 0, 0.2);flex-wrap:wrap}.title,.confirm-close,.confirm-cancel{background:#ffffff;border:none;padding:16px;line-height:20px;margin:0;font-family:Arial;font-size:14px;line-height:20px;letter-spacing:0px;text-align:left}.title{flex:1 0 auto;font-weight:700}.confirm-close{color:#c00;font-weight:700;padding-left:20px;padding-right:20px;text-align:center;cursor:pointer}.confirm-close.has-loader{display:flex;justify-content:center;align-items:center;padding-top:0;padding-bottom:0;padding-left:28px;padding-right:28px}.confirm-close:hover,.confirm-close:focus{color:#A00000}.confirm-cancel{font-weight:400;color:#828282;padding-left:20px;padding-right:20px;text-align:center;cursor:pointer}.confirm-cancel:hover,.confirm-cancel:focus{color:#000000}.overlayCover{position:absolute;left:0;top:0;right:0;bottom:0;z-index:10;border-radius:12px;background:rgba(255, 255, 255, 0.4);user-select:none}.confirmation.has-error .title{flex:1 1 auto;padding-top:6px;padding-bottom:6px}.confirmation.has-error .confirm-close{white-space:pre}.confirmation.has-error .confirm-close.has-loader{padding-left:40px;padding-right:40px}.confirmation.has-error .confirm-cancel{white-space:pre}@media only screen and (max-width: 500px){.confirmation-inner{flex-wrap:wrap;gap:0px}.title{flex:0 0 100%;box-sizing:border-box;width:100%;border-bottom:1px solid #EBEBEB;text-align:center;padding:10px 16px}.confirm-close,.confirm-cancel{flex:0 0 50%;max-width:50%;box-sizing:border-box;padding:10px 16px}.confirm-close{border-right:1px solid #EBEBEB}}";
const MapyReviewDialogConfirmationStyle0 = mapyReviewDialogConfirmationCss;

defineCustomElement$1();
const MapyReviewDialogCofirmation = /*@__PURE__*/ proxyCustomElement(class MapyReviewDialogCofirmation extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.close = createEvent(this, "close", 1);
        this.cancel = createEvent(this, "cancel", 1);
        this.onClose = (event) => {
            event.stopPropagation();
            this.close.emit({});
        };
        this.onCancel = (event) => {
            event.stopPropagation();
            this.cancel.emit({});
        };
        this.error = false;
        this.loading = false;
        this.isEdit = false;
    }
    getTitleData(locale) {
        if (this.isEdit) {
            return {
                title: transDialog(locale, "cancelChanges"),
                closeContent: transDialog(locale, "throwAway"),
                cancelTitle: transDialog(locale, "back"),
            };
        }
        const title = this.error
            ? transDialog(locale, "removeReviewError")
            : transDialog(locale, "deleteComment");
        const closeContent = this.loading
            ? h("mapy-loader", null)
            : this.error
                ? transDialog(locale, "tryAgain")
                : transDialog(locale, "delete");
        const cancelTitle = transDialog(locale, "cancel");
        return {
            title,
            closeContent,
            cancelTitle,
        };
    }
    render() {
        const locale = getLocale(this.hostElement);
        const titleData = this.getTitleData(locale);
        return h(Host, { key: '090694d6d6754ffaa6f7e845b97f2d3cfae3abea' }, h("div", { key: '171b099c5cf27cf2650ebd937e06646cd67373b6', class: classNames(["confirmation", this.error ? "has-error" : ""]) }, h("div", { key: 'd311f7ef1c3348952c1a8b1178c393bfbcd65a87', class: "confirmation-inner" }, h("p", { key: '81172dea6a816f67d3a6e43337574c0e3e5ab7d5', class: "title" }, titleData.title), h("button", { key: '9dfb7de0498af4e039b15328de78f86dd64e7778', type: "button", class: classNames(["confirm-close", this.loading ? "has-loader" : ""]), onClick: this.onClose }, titleData.closeContent), h("button", { key: '97d58104d129fdf2ec3d6e3b1f6946c8ccd3e7d9', type: "button", class: "confirm-cancel", onClick: this.onCancel }, titleData.cancelTitle)), this.loading && h("div", { key: '4f027aaedde80a58235c03265bdbe7519516ec1b', class: "overlayCover" })));
    }
    get hostElement() { return this; }
    static get style() { return MapyReviewDialogConfirmationStyle0; }
}, [1, "mapy-review-dialog-confirmation", {
        "error": [516],
        "loading": [516],
        "isEdit": [516, "is-edit"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mapy-review-dialog-confirmation", "mapy-loader"];
    components.forEach(tagName => { switch (tagName) {
        case "mapy-review-dialog-confirmation":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MapyReviewDialogCofirmation);
            }
            break;
        case "mapy-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement();

export { MapyReviewDialogCofirmation as M, defineCustomElement as d };

//# sourceMappingURL=mapy-review-dialog-confirmation2.js.map